<template>
  <label class="label78">
    <input type="checkbox" class="checkbox78" v-model="isLight" />
    <div class="status78"></div>
  </label>
</template>

<script>
export default {
  name: "CheckMode",
  data() {
    return {
      isLight: true,
    };
  },
  watch: {
    isLight(v) {
      const body = document.body;
      if (v) {
        body.classList.add("light");
      } else {
        body.classList.remove("light");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.label78 {
  position: fixed;
  z-index: 99999;
  cursor: pointer;
  overflow: hidden;
  top: 4px;
  right: 4px;
  scale: 0.6;
}
.checkbox78 {
  width: 90px;
  height: 40px;
  background-color: #000000;
  border-radius: 20px;
  margin: 0;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.4s linear;
  appearance: none;
  -webkit-appearance: none;
}
.status78 {
  width: 16px;
  height: 16px;
  background-color: transparent;
  box-shadow: inset -6px -4px 0 yellow;
  border-radius: 50%;
  position: absolute;
  right: 17px;
  top: 12px;
  transition: all 0.4s linear;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status78:after {
  content: "夜间";
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 3px;
  line-height: 1;
  position: absolute;
  left: -38px;
  top: 1px;
}
.checkbox78:checked {
  background-color: #ebebeb;
}
.checkbox78:checked + .status78 {
  width: 16px;
  height: 16px;
  box-shadow: inset -16px -16px 0 #ffc20e;
  right: 17px;
}
.checkbox78:checked + .status78:after {
  content: "日间";
  color: #000000;
}
</style>
